import { useWeekday } from 'helpers/hooks'
import { type IScheduledListDate } from 'types/interfaces/ITypes'

import styles from './ScheduledListDate.module.scss'
import { ScheduledListItem } from '../ScheduledIListItem'

interface ScheduleListDateProps {
    onEditClick: (
        postType: string,
        postId: string,
        scheduleId: string
    ) => any
    contentOnDate: IScheduledListDate
    date: Date | null
}

export const ScheduledListDate = ({
    onEditClick,
    contentOnDate,
    date
}: ScheduleListDateProps) => {
    const weekday = useWeekday()

    return (
        <>
            {contentOnDate &&
                (() => {
                    const today = date ? new Date(date) : new Date()
                    today.setHours(0, 0, 0, 0)

                    const maxDate = new Date(today)
                    maxDate.setDate(today.getDate() + (date ? 0 : 7))
                    maxDate.setHours(23, 59, 59, 999)

                    const postDate = new Date(
                        today.getFullYear(),
                        today.getMonth(),
                        contentOnDate.date.dayOfMonth
                    )

                    postDate.setHours(0, 0, 0, 0)

                    if (postDate >= today && postDate <= maxDate) {
                        return (
                            <div className={styles.container}>
                                <div className={styles.number}>
                                    {contentOnDate.date.dayOfMonth < 10
                                        ? `0${contentOnDate.date.dayOfMonth}`
                                        : contentOnDate.date.dayOfMonth}{' '}

                                    <span>
                                        {weekday.getWeekday(
                                            contentOnDate.date.nameOfDay,
                                            'full'
                                        )}
                                    </span>
                                </div>

                                <ul className={styles.list}>
                                    {contentOnDate.list.map(element => (
                                        <ScheduledListItem
                                            key={element.scheduleId}
                                            onEditClick={onEditClick}
                                            listItem={element}
                                        />
                                    ))}
                                </ul>
                            </div>
                        )
                    }

                    return null
                })()}
        </>
    )
}